module.exports = Object.freeze({
	IN_STOCK: 'InStock',
	OUT_OF_STOCK: 'OutOfStock',
	PRE_SALE: 'PreSale',
	PRE_ORDER: 'PreOrder',
})
